import React from 'react';

const ReposContext = React.createContext<BB.Repository[] | undefined>([]);
ReposContext.displayName = 'ReposContext';

export default ReposContext;
